export default __webpack_public_path__ + "static/media/img_blog08.cae88b65.jpg";